<template>
  <h2 class="text-center">{{ pageItem.title }}</h2>
  <h3 v-if="pageItem.text" class="text-center mb-4">{{ pageItem.text }}</h3>
  <div class="row justify-content-center">
    <div v-for="(item, index) in pageItem.items"
      :key="index"
      class="col-6 col-sm-3 col-lg-2 text-center">
			
      <!--<img v-if="!item.video" :src="`${publicPath}`+ item.image" v-bind:alt="item.title" v-bind:data-caption="(item.title !== pageTitle) ? item.title +' - '+ pageTitle : pageTitle" class="img-fluid mb-3" data-fancybox="gallery" />-->
			
      <a v-if="!item.video" :href="`${publicPath}`+ item.image" v-bind:data-caption="(item.title !== pageTitle) ? item.title +' - '+ pageTitle : pageTitle" data-fancybox="gallery">
				<img :src="`${publicPath}`+ item.thumb" class="img-fluid mb-3" v-bind:alt="item.title" />
			</a>
			
      <a v-if="item.video" :href="`${publicPath}`+ item.video" v-bind:data-caption="(item.title !== pageTitle) ? item.title +' - '+ pageTitle : pageTitle" data-fancybox="gallery">
				<img :src="require('../../assets/thumbnail-videogallery.jpg')" class="img-fluid mb-3" v-bind:alt="item.title" />
			</a>
			
    </div>
  </div>
</template>

<script>
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";

Fancybox.bind("[data-fancybox]", {
  // Your options go here
});

export default {
  name: 'GalleryPage',
  props: ['pageItem', 'pageTitle', 'pageText'],
  data () {
    return {
      publicPath: process.env.BASE_URL
    }
  }
}
</script>

<style>
</style>

<style scoped>
</style>
